import myDate from './dateManager.js';
import myCopier from './copyManager.js';

var copyAs = myCopier.copyAs;
var copy = myCopier.copy;

var initValues = {
  "WeakPW": "",
  "MediumPW": "",
  "StrongPW": "",
  "posNum": "0",
  "nonNeg": "0",
  "negNum": "0",
  "nonPos": "0",
  "time": "08:00",
  "multi-time": [],
  "date": myDate.displayCurrentDate({
    sequence: "y-m-d",
  }),
  "date-time": "",
  "phone": "",
  "email": "",
  "text": "",
  "none": "",
  "Array": [],
  "JSON": {}
}

var checkFuns = {
  "multi-time": function(input){
    var output = "";
    var error = "";
    var errorMsg = [];
    var msgNow = {};
    input.forEach(r=>{
      msgNow = {
        Start: "",
        End: "",
      }
      output += r.Start + "-" + r.End + ",";
      if (r.Start == "" || r.Start == undefined){
        msgNow.Start = "Value is empty.";
        error = true;
      }
      if (r.End == "" || r.End == undefined){
        msgNow.End = "Value is empty.";
        error = true;
      }
      errorMsg.push(msgNow);
    })
    output = output.substring(0, output.length - 1);
    return {
      error: error,
      errorMsg: errorMsg,
      output: output
    }
  },
  none: function(input){
    if (input == undefined){
      input = "";
    }
    return {
      error: false,
      errorMsg: "",
      output: input
    }
  },


  //------------------------ TEXT ------------------------//
  text: function(input){
    if (input == undefined){
      input = "";
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error =  false;
    var errorMsg = "";

    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }

    return {
      error: error,
      errorMsg: errorMsg,
      output: input
    }
  },

  // EMAIL
  email: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var notEmail = false;
    var errorMsg = "";
    if (input.includes(" ")){
      notEmail = true;
    }

    if (!notEmail){
      var aliasIndex = input.indexOf("@");  
      if (aliasIndex == -1){
        notEmail = true;
        errorMsg = "Missing an @";
      }
      else{
        var subsequent = input.substring(aliasIndex + 1, input.length - 1);
        if (!subsequent.includes(".")){
          notEmail = true;
          errorMsg = "Missing domain path.";
        }
      }
    }
    return {
      error: notEmail || (input == undefined) || (input == ""),
      errorMsg: errorMsg,
      output: input
    }
  },

  // ADDRESS
  street: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var notStreet = false;
    var errorMsg = "";
    var error = false;

    var aliasIndex = input.indexOf(",");  

    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (aliasIndex == -1){
      notStreet = true;
      errorMsg = "Missing a , between street name and number";
    }
    return {
      error: notStreet || (input == undefined) || (input == ""),
      errorMsg: errorMsg,
      output: input
    }
  },


  //--------------------- PASSWORD -------------------//
  // WEAK
  WeakPW: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error =  false;
    var errorMsg = "";

    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (input.length < 6){
      error = true;
      errorMsg = "Password must be 6 characters or more.";
    }

    return {
      error: error,
      errorMsg: errorMsg,
      output: input
    }
  },

  // MEDIUM
  mediumPW: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error =  false;
    var errorMsg = "";

    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (input.length < 8){
      error = true;
      errorMsg = "Password must be 8 characters or more.";
    }

    return {
      error: error,
      errorMsg: errorMsg,
      output: input
    }
  },

  // STRONG
  strongPW: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error =  false;
    var errorMsg = "";


    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (input.length < 8){
      var containsAlpha = false;
      var containsNum = false;
      var c;

      for (var i = 0; i < input.length; i++){
        c = input[i];
        if (c >= '0' && c <= '9') {
          containsNum = true;
        }
        else if (c.match(/[a-z]/i)){
          containsAlpha = true;
        }
      }

      if (!containsAlpha || !containsNum){
        error = true;
        errorMsg = "Password must be 8 characters or more and contain both alphabets and numbers.";
      }
    }
    else{
      var containsAlpha = false;
      var containsNum = false;
      var c;

      for (var i = 0; i < input.length; i++){
        c = input[i];
        if (c >= '0' && c <= '9') {
          containsNum = true;
        }
        else if (c.match(/[a-z]/i)){
          containsAlpha = true;
        }
      }

      if (!containsAlpha || !containsNum){
        error = true;
        errorMsg = "Password must contain both alphabets and numbers.";
      }
    }

    return {
      error: error,
      errorMsg: errorMsg,
      output: input
    }
  },

  //REPEAT
  repeatPW: function(input, input2){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error =  false;
    var errorMsg = "";
    // if (input != input2){
    //   error = true;
    //   errorMsg = "Passwords do not match";
    // };
    return {
      error: error,
      errorMsg: errorMsg,
      output: input
    }
  },


  //--------------------- NUMBER ----------------------//
  posNum: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error, errorMsg = "";   
    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (parseFloat(input) <=0){
      
      error = true;
      errorMsg = "Value cannot be 0 or below.";
    }
    return {
      error: error,
      errorMsg: errorMsg,
      output: parseFloat(input)
    }
  },
  negNum: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error, errorMsg = "";  
    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (parseFloat(input) >=0){
      error = true;
      errorMsg = "Value cannot be 0 or more.";
    }
    return {
      error: error,
      errorMsg: errorMsg,
      output: parseFloat(input)
    }
  },
  nonPos: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error, errorMsg = "";  
    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (parseFloat(input) <0){
      error = true;
      errorMsg = "Value cannot be more than 0.";
    }
    return {
      error: error,
      errorMsg: errorMsg,
      output: parseFloat(input)
    }
  },
  nonNeg: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error, errorMsg = "";  
    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (parseFloat(input) <0){
      error = true;
      errorMsg = "Value cannot be less than 0.";
    }
    return {
      error: error,
      errorMsg: errorMsg,
      output: parseFloat(input)
    }
  },
  date: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    var error, errorMsg = "";  
    var d = new Date(input);
    var timeNow = d.getTime();
    if (input == ""){
      error = true;
      errorMsg = "Value is empty.";
    }
    else if (timeNow <0){
      error = true;
      errorMsg = "Invalid Date";
    }
    return {
      error: error,
      errorMsg: errorMsg,
      output: timeNow
    }
  },

  phone: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    return checkFuns["text"](input);
  },
  time: function(input){
    if (input == undefined){
      return{
        error: true,
        errorMsg: "Value is undefined",
        output: "",
      }
    }
    return checkFuns["text"](input);
  },
};

var reverseFuns = {
  none: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },


  //------------------------ TEXT ------------------------//
  text: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },

  // EMAIL
  email: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },

  // ADDRESS
  street: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },


  //--------------------- PASSWORD -------------------//
  // WEAK
  WeakPW: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },

  // MEDIUM
  mediumPW: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },

  // STRONG
  strongPW: function(input){
    return {
      errorMsg: "",
      output: input
    }
  },

  //REPEAT
  repeatPW: function(input, input2){
    return {
      errorMsg: "",
      output: input
    }
  },


  //--------------------- NUMBER ----------------------//
  posNum: function(input){
    return {
      errorMsg: "",
      output: (input).toString()
    }
  },
  negNum: function(input){
    return {
      errorMsg: "",
      output: (input).toString()
    }
  },
  nonPos: function(input){
    return {
      errorMsg: "",
      output: (input).toString()
    }
  },
  nonNeg: function(input){
    return {
      errorMsg: "",
      output: (input).toString()
    }
  },
  date: function(input){
    var error, errorMsg;  
    var d = new Date(input);
    d.setTime(input);

    var month, day;
    month = d.getMonth() + 1;
    day = d.getDate();

    if (month < 10){
      month = "0" +  month;
    }
    if (day < 10){
      day = "0" +  day;
    }

    return {
      errorMsg: "",
      output: d.getFullYear() + "-" + month + "-" + day 
    }
  },

  phone: function(input){
    return reverseFuns["text"](input);
  },
  time: function(input){
    return reverseFuns["text"](input);
  },
  "multi-time": function(input){
    var output = [];
    var error = "";
    var errorMsg = [];
    var msgNow = {};
    input.split(",").forEach(r=>{
      if (r != ""){
        output.push({
          Start: r.substring(0,5),
          End: r.substring(6,11),
        })
        errorMsg.push({
          Start: "",
          End: ""
        });
      };
    })
    return {
      errorMsg: errorMsg,
      output: output
    }
  },
};

var init = function(input){
  var output = {};
  input.forEach(i=>{
    if (i.type == "JSON"){
      output[i.Name] = init(i.children).output;
    }
    else if (i.type == "Array"){
      output[i.Name] = [];
    }
    else{
      output[i.Name] = copy(initValues[i.checkFun]);
    }
  })
  return {
    output: output,
    errorMsg: copyAs(output, "")
  }
}

var checkMain = function(input, template){
  var output = {};
  var error = false;
  var errorMsg = {};

  var checkers = {
    "JSON"(inp, temp){
      var error = false;
      var outputNow;
      var output = {};
      var errorMsg = {};
      temp.forEach(c=>{
        outputNow = checkFuns[c.checkFun](inp[c.Name]);
        error = error || outputNow.error;
        output[c.Name] = outputNow.output;
        errorMsg[c.Name] = outputNow.errorMsg;
        if (outputNow.error){
          console.log("Error: " + c.Name + " " + outputNow.errorMsg);
        }
      })
      return {
        output: output,
        error: error,
        errorMsg: errorMsg
      };
    },
    "Array"(inp, temp){
      var error = false;
      var output = [];
      var errorMsg = [];
      var outputNow = {};
      var outputElement = {};
      var errorMsgElement = {};

      inp.forEach(i=>{
        outputElement = {}; 
        errorMsgElement = {};
        temp.forEach(c=>{
          outputNow = checkFuns[c.checkFun](i[c.Name]);
          error = error || outputNow.error;
          outputElement[c.Name] = outputNow.output;
          errorMsgElement[c.Name] = outputNow.errorMsg;
          if (outputNow.error){
            console.log("Error: " + c.Name + " " + outputNow.errorMsg);
          }
        })
        output.push(outputElement);
        errorMsg.push(errorMsgElement);

      })
      return {
        output: output,
        error: error,
        errorMsg: errorMsg
      };
    },
    "Others"(inp, temp){
      var outputNow = checkFuns[temp.checkFun](inp);
      return{
        output: outputNow.output,
        error: outputNow.error,
        errorMsg: outputNow.errorMsg
      }
    }
  }

  var special = ["Array", "JSON"];
  var outputNow;
  template.forEach(t=>{
    if (special.includes(t.type)){
      outputNow = checkers[t.type](input[t.Name], t.children);
      output[t.Name] = outputNow.output;
      errorMsg[t.Name] = outputNow.errorMsg;
      error = outputNow.error || error;
    }
    else{
      outputNow = checkers["Others"](input[t.Name], t);
      output[t.Name] = outputNow.output;
      errorMsg[t.Name] = outputNow.errorMsg;
      error = outputNow.error || error;
      if (outputNow.error){
        console.log("Error: " + t.Name + " " + outputNow.errorMsg);
      }
    }
  })
  for (var item in input){
    if (output[item] == undefined){
      output[item] = copy(input[item]);
      errorMsg[item] = copyAs(input[item], "");
    }
  }
  return {
    output,
    errorMsg,
    error,
  }
}

var editMain = function(input, template){
  var output = {};
  var error = false;
  var errorMsg = {};

  var checkers = {
    "JSON"(inp, temp){
      var error = false;
      var outputNow;
      var output = {};
      var errorMsg = {};

      if (inp == undefined){
        inp = {};
      }
      temp.forEach(c=>{
        if (inp[c.Name] == undefined){
          outputNow = {
            output: copy(initValues[c.checkFun]),
            error: false,
            errorMsg: ""
          }
        }
        else{
          outputNow = reverseFuns[c.checkFun](inp[c.Name]);
        }
        error = error || outputNow.error;
        output[c.Name] = outputNow.output;
        errorMsg[c.Name] = outputNow.errorMsg;
      })
      return {
        output: output,
        error: error,
        errorMsg: errorMsg
      };
    },
    "Array"(inp, temp){
      var inp = inp || [];
      var error = false;
      var output = [];
      var errorMsg = [];
      var outputNow = {};
      var outputElement = {};
      var errorMsgElement = {};

      if (inp == undefined){
        inp = [];
      }
      inp.forEach(i=>{
        outputElement = {}; 
        errorMsgElement = {};
        temp.forEach(c=>{
          outputNow = reverseFuns[c.checkFun](i[c.Name]);
          error = error || outputNow.error;
          outputElement[c.Name] = outputNow.output;
          errorMsgElement[c.Name] = outputNow.errorMsg;
        })
        output.push(outputElement);
        errorMsg.push(errorMsgElement);
      })
      return {
        output: output,
        error: error,
        errorMsg: errorMsg
      };
    },
    "Others"(inp, temp){
      if (inp == undefined){
        return {
          output: copy(initValues[temp.checkFun]),
          error: false,
          errorMsg: "",
        }
      }
      else{
        var outputNow = reverseFuns[temp.checkFun](inp);
        return{
          output: outputNow.output,
          error: outputNow.error,
          errorMsg: outputNow.errorMsg
        }
      }
    }
  }

  var special = ["Array", "JSON"];
  var outputNow;
  template.forEach(t=>{
    if (special.includes(t.type)){
      outputNow = checkers[t.type](input[t.Name], t.children);
      output[t.Name] = outputNow.output;
      errorMsg[t.Name] = outputNow.errorMsg;
      error = outputNow.error || error;
    }
    else{
      outputNow = checkers["Others"](input[t.Name], t);
      output[t.Name] = outputNow.output;
      errorMsg[t.Name] = outputNow.errorMsg;
      error = outputNow.error || error;
    }
  })
  for (var item in input){
    if (output[item] == undefined){
      output[item] = copy(input[item]);
      errorMsg[item] = copyAs(input[item], "");
    }
  }
  return {
    output,
    errorMsg,
    error,
  }
}

export default{
  init,
  checkMain,
  editMain
}



// WEBPACK FOOTER //
// ./src/assets/js/inputManager.js